import PropTypes from 'prop-types';
// @mui
import { styled } from '@mui/material/styles';
import { List, Box, ListSubheader } from '@mui/material';
import { LoadingButton } from '@mui/lab';
import { Icon } from '@iconify/react';
//
// import { useNavigate } from 'react-router';
import useAuth from '../../../hooks/useAuth';
import { NavListRoot } from './NavList';

// ----------------------------------------------------------------------

export const ListSubheaderStyle = styled((props) => <ListSubheader disableSticky disableGutters {...props} />)(
  ({ theme }) => ({
    ...theme.typography.overline,
    paddingTop: theme.spacing(3),
    paddingLeft: theme.spacing(2),
    paddingBottom: theme.spacing(1),
    color: 'white',
    transition: theme.transitions.create('opacity', {
      duration: theme.transitions.duration.shorter,
    }),
  })
);

// ----------------------------------------------------------------------

NavSectionVertical.propTypes = {
  isCollapse: PropTypes.bool,
  navConfig: PropTypes.array,
};

export default function NavSectionVertical({ navConfig, isCollapse = false, ...other }) {
  const { logout } = useAuth();
  const handleLogout = async () => {
    try {
      await logout();
      window.location.href = "https://sdsuser.dev-bt.xyz/";


    } catch (error) {
      console.error(error);
    }
  };
  const role = JSON.parse(localStorage.getItem("accounts"))
  console.log(role, "role")
  return (
    <Box {...other}>
      {role.role === "Primary" ? (
        <>
          {navConfig[0].items.map((group) => (
            <List key={group.subheader} disablePadding sx={{ px: 2 }}>
              <NavListRoot key={group.title} list={group} isCollapse={isCollapse} />
            </List>
          ))}
        </>
      )
        :
        (
          <>
            {navConfig[1].items.map((group) => (
              <List key={group.subheader} disablePadding sx={{ px: 2 }}>
                <NavListRoot key={group.title} list={group} isCollapse={isCollapse} />
              </List>
            ))}
          </>
        )
      }
      <Box sx={{ display: "flex", justifyContent: "start", px: 2, marginTop: '50%', ml: 5 }}>
        <LoadingButton sx={{ fontSize: 20, color: 'white' }} onClick={handleLogout}> <Icon icon="basil:logout-solid" />Sign out</LoadingButton>
      </Box>
    </Box>
  );
}
